import {ApplicationSourceSection} from "../types/ApplicationSourceSection";

export function getApplicationSourceSectionDisplay(sourceSection: ApplicationSourceSection): string {
    switch (sourceSection) {
        case ApplicationSourceSection.PropertyBoxLeadModal:
            return `Box nieruchomości - zapytanie wysłane z modala formularza`;
        case ApplicationSourceSection.PropertyBoxOneClickLead:
            return `Box nieruchomości - zapytanie wysłane z one click lead`;
        case ApplicationSourceSection.PropertyModalOneClickLead:
            return `Modal nieruchomości - zapytanie wysłane z one click lead`;
        case ApplicationSourceSection.PropertyModalLeadModal:
            return `Modal nieruchomości - zapytanie wysłane z modala formularza`;
        case ApplicationSourceSection.PropertyModalOneClickLeadMobileModal:
            return `Modal nieruchomości - zapytanie wysłane z mobile modala one click lead`;
        case ApplicationSourceSection.PropertyModalLeadModalMobile:
            return `Modal nieruchomości - zapytanie wysłane z mobile modala formularza`;
        case ApplicationSourceSection.AfterRecommendationLikeQuestionOneClickLead:
            return `Zapytanie wysłane z one click lead po kliknięciu "zapytaj o ofertę" na widoku "Czy chcesz teraz zrobić?"`;
        case ApplicationSourceSection.AfterFavouriteLikeQuestionOneClickLead:
            return `Zapytanie wysłane z one click lead po kliknięciu "Tak" na widoku "Czy chcesz teraz zapytać o tę ofertę?"`;
        case ApplicationSourceSection.AfterRecommendationLikeQuestionModal:
            return `Zapytanie wysłane z Modala po kliknięciu "zapytaj o ofertę" na widoku "Czy chcesz teraz zrobić?"`;
        case ApplicationSourceSection.AfterFavouriteLikeQuestionModal:
            return `Zapytanie wysłane z Modala po kliknięciu "Tak" na widoku "Czy chcesz teraz zapytać o tę ofertę?"`;
        case ApplicationSourceSection.RecommendedPropertiesCarouselAskOffer:
            return `Karuzela "Rekomendowane nieruchomości" — CTA Zapytaj o ofertę`;

        default:
            return "";
    }
}
import {ApplicationSourceSection} from "../types/ApplicationSourceSection";

export function getApplicationSourceSectionDisplay(sourceSection: ApplicationSourceSection): string {
    switch (sourceSection) {
        case ApplicationSourceSection.PropertyBoxLeadModal:
            return `Box nieruchomości - zapytanie wysłane z modala formularza`;
        case ApplicationSourceSection.PropertyBoxOneClickLead:
            return `Box nieruchomości - zapytanie wysłane z one click lead`;
        case ApplicationSourceSection.PropertyModalOneClickLead:
            return `Modal nieruchomości - zapytanie wysłane z one click lead`;
        case ApplicationSourceSection.PropertyModalLeadModal:
            return `Modal nieruchomości - zapytanie wysłane z modala formularza`;
        case ApplicationSourceSection.PropertyModalOneClickLeadMobileModal:
            return `Modal nieruchomości - zapytanie wysłane z mobile modala one click lead`;
        case ApplicationSourceSection.PropertyModalLeadModalMobile:
            return `Modal nieruchomości - zapytanie wysłane z mobile modala formularza`;
        case ApplicationSourceSection.AfterRecommendationLikeQuestionOneClickLead:
            return `Zapytanie wysłane z one click lead po kliknięciu "zapytaj o ofertę" na widoku "Czy chcesz teraz zrobić?"`;
        case ApplicationSourceSection.AfterFavouriteLikeQuestionOneClickLead:
            return `Zapytanie wysłane z one click lead po kliknięciu "Tak" na widoku "Czy chcesz teraz zapytać o tę ofertę?"`;
        case ApplicationSourceSection.AfterRecommendationLikeQuestionModal:
            return `Zapytanie wysłane z Modala po kliknięciu "zapytaj o ofertę" na widoku "Czy chcesz teraz zrobić?"`;
        case ApplicationSourceSection.AfterFavouriteLikeQuestionModal:
            return `Zapytanie wysłane z Modala po kliknięciu "Tak" na widoku "Czy chcesz teraz zapytać o tę ofertę?"`;
        case ApplicationSourceSection.RecommendedPropertiesCarouselAskOffer:
            return `Karuzela "Rekomendowane nieruchomości" — CTA Zapytaj o ofertę`;

        default:
            return "";
    }
}
